export default function PersistedStorage(key) {
  const set = (data: any) => localStorage.setItem(key, data);
  const get = (): ?any => localStorage.getItem(key);
  const remove = () => localStorage.removeItem(key);

  return {
    set,
    get,
    remove,
  };
}


// WEBPACK FOOTER //
// ./src/lib/PersistedStorage.js